//import $ from 'jquery';

const
  NAME                   = 'collapseBootstrapMenus',
  VERSION                = '1.0.0',
  JQUERY_NO_CONFLICT     = $.fn[NAME],

  NAVBAR_OPENED_SELECTOR = '.collapse.in',
  CLOSE_CLASS            = 'close-x',
  HIDE                   = 'hide',
  COMMENTS_CLASS         = 'voc-comments-container'
;

class CollapseBootstrapMenus {
  constructor(element$) {
    this._element$ = element$;
    element$.on('click', this.onClick.bind(this));
  }

  onClick(event) {
    var navbar$, clickOver$, clickInside$;

    navbar$      = this._element$.find(NAVBAR_OPENED_SELECTOR);
    clickOver$   = $(event.target);
    clickInside$ = $(clickOver$).closest(navbar$).length;

    if ((!clickInside$ || clickOver$.hasClass(CLOSE_CLASS)) && !navbar$.hasClass(COMMENTS_CLASS)) {
      navbar$.collapse(HIDE);
    }

  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new CollapseBootstrapMenus($(this));
    });
  }
}

$.fn[NAME]             = CollapseBootstrapMenus._jQueryInterface;
$.fn[NAME].Constructor = CollapseBootstrapMenus;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return CollapseBootstrapMenus._jQueryInterface;
};

export default CollapseBootstrapMenus;



// WEBPACK FOOTER //
// ./src/plugins/collapse-bootstrap-menus.js